<template>
  <el-dialog :title="title" :visible.sync="open" width="700px" append-to-body>
    <div class="addAudio">
      <div class="addAudio_left">
        <span class="addAudio_left_title">内容</span>
        <el-input
          type="textarea"
           :autosize="{ minRows: 8, maxRows: 15}"
          placeholder="请输入要识别的内容"
          v-model="content"
        >
        </el-input>
      </div>
      <div class="addAudio_midden">
        
          <span class="addAudio_tips" v-if="identify">文本过长，请耐心等待...</span>
        <el-button type="primary" plain v-if="identify" disabled>识别中</el-button>
        <el-button type="primary" plain @click="textChange" v-else>识别</el-button>
      </div>
      <div class="addAudio_right">
        <span class="addAudio_left_title">识别结果</span>
        <div class="addAudio_right_box">
          <!-- <span>{{ voiceLink }}</span> -->
          <div class="addAudio_right_box_bottom" v-if="voiceLink">
            <audio controls class="addAudio_right_box_bottom_audio" :src="voiceLink">
              <!-- <source :src="voiceLink" type="audio/mpeg" /> -->
            </audio>
            <!-- <i class="el-icon-video-play"></i> -->
            <el-button
              type="primary"
              icon="el-icon-download"
              circle
              @click="downloadFileWithAuth"
            ></el-button>
          </div>
          <el-empty description="暂无识别结果" v-if="!voiceLink"></el-empty>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import axios from "axios";
import { addVoiceSynthesis, speechSynthesis } from "@/api/index";
export default {
  components: {},
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      loading: false,
      total: 0,
      dataList: [],
      showSearch: true,
      title: "",
      // 是否显示弹出层
      open: false,
      content: "",
      voiceLink:'',
        // "https://chiness-clothing.oss-cn-beijing.aliyuncs.com/alyImg/088a4ab7-.wav",
        userId: "",
        userName: "",
        platForm: "",
        identify:false
    };
  },
  created() {},
  mounted() {
  },
  methods: {
    addCreateForm(userId, userName, platForm) {
      console.log(123);
      this.reset();
      this.open = true;
      this.title = "添加语音";
      this.userId = userId;
      this.userName = userName;
      this.platForm = platForm;

    },
    textChange(e) {
      console.log(e.target.value, e, this.content);
      this.voiceLink = ''
      if (!this.content) {
        return;
      }
        this.identify = true
      speechSynthesis({ text: this.content }).then((response) => {
        console.log(response);
        this.voiceLink = response.data.data;
        this.$modal.msgSuccess("识别成功");
        this.identify = false
      });
    },
    /** 提交按钮 */
    submitForm() {
      const data = {
        content: this.content,
        voiceLink: this.voiceLink,
        userId: this.userId,
        userName: this.userName,
        platForm: this.platForm,
        type:1
      };
      addVoiceSynthesis(data).then((response) => {
        this.$modal.msgSuccess("新增成功");
        this.open = false;
        this.$emit("ok");
      });
    },
    calculateEndTime(startTimeStr, hoursToAdd) {
      // 将时间字符串转换为 Date 对象
      const date = new Date(startTimeStr.replace(" ", "T")); // 支持 "YYYY-MM-DD HH:mm:ss"
      // 检查是否为有效时间
      console.log(date);
      if (isNaN(date.getTime())) {
        throw new Error("Invalid date format");
      }
      // 加上指定的小时数（支持小数，如 1.5 表示 1小时30分钟）
      date.setTime(date.getTime() + hoursToAdd * 60 * 60 * 1000);

      // 格式化为 "YYYY-MM-DD HH:mm:ss"
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hour = String(date.getHours()).padStart(2, "0");
      const minute = String(date.getMinutes()).padStart(2, "0");
      const second = String(date.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    // 表单重置
    reset() {
       this.content = "";
      this.voiceLink = "";
      this.identify = false
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    async downloadFileWithAuth() {
      const fileUrl = this.voiceLink; // 需要认证的 URL
      const fileName = "audio.mp3"; // 你期望的文件名

      try {
        // 使用 axios 请求文件，responseType 设置为 'blob'
        const response = await axios.get(fileUrl, {
          responseType: "blob", // 关键：告诉 axios 将响应作为二进制大对象处理
          headers: {
            // 如果需要认证，添加请求头
            // 'Authorization': 'Bearer your-jwt-token-here'
            // 其他可能的头...
          },
        });
        console.log(response);
        // 检查响应状态
        if (response.status === 200) {
          // 创建一个 Blob URL
          const blob = new Blob([response.data], { type: response.data.type });
          console.log(blob);
          const url = window.URL.createObjectURL(blob);
          console.log(url);
          // 创建一个临时的 <a> 标签来触发下载
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName; // 设置下载的文件名
          document.body.appendChild(link);
          link.click();

          // 清理：移除元素并释放 Blob URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          this.$modal.msgSuccess("下载成功");
        } else {
          console.error("下载失败:", response.statusText);
        }
      } catch (error) {
        console.error("下载过程中出错:", error);
        // 处理错误，例如显示错误消息
      }
    },
  },
};
</script>
<style scoped>
.addAudio {
  display: flex;
  justify-content: space-between;
  /* align-items: center; */
}
.addAudio_left {
  width: 38%;
}
.addAudio_left_title {
  font-size: 24px;
  margin-bottom: 20px;
  display: block;
  width: 100%;
  text-align: center;
}
.addAudio_midden {
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.addAudio_right {
  width: 38%;
}
.addAudio_right_box {
  display: flex;
  flex-direction: column;
}
.addAudio_right_box_bottom {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.addAudio_right_box_bottom_audio {
  width: 100%;
  margin-bottom: 20px;
}
.addAudio_tips{
  font-size: 12px;
  color: red;
  margin-bottom: 10px;
  display: block;
}
</style>